import { render, staticRenderFns } from "./IconSpinner.vue?vue&type=template&id=50872196&scoped=true&"
import script from "./IconSpinner.vue?vue&type=script&lang=js&"
export * from "./IconSpinner.vue?vue&type=script&lang=js&"
import style0 from "./IconSpinner.vue?vue&type=style&index=0&id=50872196&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50872196",
  null
  
)

export default component.exports